import React, { useEffect, useRef, useState } from 'react';
import ModalComponent from '../../components/ModalComponent';
import '../../assets/style/Modal.css';
import {
  accommodationDataBlank,
  APPLY_REIMBURSEMENT_TYPES,
  CLICK_ACTIONS,
  DefaultClaimType,
  foodFormDataBlank,
  miscellaneousDataBlank,
  REIMBURSEMENT_CLIAM_TYPES,
  travelFormDataBlank,
} from '../../utils/Constant';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Badge,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import ModalHeader from '../../components/ModalHeader';
import { Col, Form, FormGroup, Image, Row } from 'react-bootstrap';
import MDatePicker from '../../components/MDatePicker';
import Calendar from '../../assets/img/calendar.svg';
import Attachment from '../../assets/img/ic_attachment.svg';
import MTextField from '../../components/MTextField';
import { Button, Input, Label } from 'reactstrap';
import {
  AccomodationFromData,
  ClaimType,
  ColXsMdType,
  FoodFromData,
  MiscellaneousFromData,
  MUILocationFilterType,
  SelectOptionType,
  TravelFromData,
} from '../../utils/Types';
import { isAPIFailed, isAPISuccess } from '../../utils/Util';
import {
  fetchReimbursementTypes,
  postApplyReimbursement,
  reimbursementSelector,
} from '../../features/reimbursementSlice';
import { toast } from 'react-toastify';
import MUILocationFilter from '../../components/MUILocationFilter';
import moment from 'moment';
import CenterSpinner from '../../components/CenterSpinner';
import {
  getReqData,
  handleFileChange,
  reimbursementLocationDetails,
  uploadAttachments,
  validation,
} from '../reimbursement/ReimbursementHelper';
import { useLoader } from '../../loader/LoaderProvider';

export const MODAL_TYPE = {
  apply: 1,
  approve: 2,
};
interface IApplyReimbursementModalProps {
  isOpen: boolean;
  toggleModal: (action?: string) => void;
  modalType: number;
  selectedTask: any;
  claimTypeMode: string | null;
}

const colSize: ColXsMdType = {
  xs: 12,
  md: 6,
};
const regex = /[^0-9.]+|(\..*)\./g;
const numberRestrictionRegex = /^\d{0,10}(\.\d{0,2})?$/;
const alphabetRegex = /[^a-zA-Z\s]/g;
const distanceRegex = /^\d{0,4}(\.\d{0,2})?$/;

const ApplyReimbursementModal: React.FunctionComponent<
  IApplyReimbursementModalProps
> = ({
  isOpen,
  toggleModal,
  modalType,
  selectedTask,
  claimTypeMode,
}: IApplyReimbursementModalProps) => {
  const initializeFormData = (blankData: any) => ({
    ...blankData,
    claimFromDate: moment(new Date()).format('DD-MM-YYYY H:mm'),
  });

  const initializeAccommodationFormData = (blankData: any) => ({
    ...blankData,
    claimFromDate: moment(new Date()).format('DD-MM-YYYY H:mm'),
    claimToDate: moment(new Date()).format('DD-MM-YYYY H:mm'),
  });

  const [foodFormData, setFoodFormData] = useState<FoodFromData>(
    initializeFormData(foodFormDataBlank)
  );

  const [travelFormData, setTravelFormData] = useState<TravelFromData>(
    initializeFormData(travelFormDataBlank)
  );

  const [miscellaneous, setMiscellaneous] = useState<MiscellaneousFromData>(
    initializeFormData(miscellaneousDataBlank)
  );

  const [accommodation, setAccommodation] = useState<AccomodationFromData>(
    initializeAccommodationFormData(accommodationDataBlank)
  );

  const [imagesList, setImagesList] = useState<any>({});
  const [expandedIndex, setExpandedIndex] = useState<number | null>(0);
  const { showLoader, setShowLoader } = useLoader();
  const [disableTravelField, setDisableTravelField] = useState<any>({});
  const [activeClaimUpload, setActiveClaimUpload] = useState<number | string>(
    ''
  );

  const TYPE_OF_CLAIM: SelectOptionType[] = useAppSelector(
    reimbursementSelector
  ).reimbursementTypes;

  const travelImagesCount =
    imagesList?.[REIMBURSEMENT_CLIAM_TYPES?.Travel]?.length || 0;
  const foodImagesCount =
    imagesList?.[REIMBURSEMENT_CLIAM_TYPES?.Food]?.length || 0;
  const accomadationImagesCount =
    imagesList?.[REIMBURSEMENT_CLIAM_TYPES?.Accommodation]?.length || 0;
  const miscellaneousImagesCount =
    imagesList?.[REIMBURSEMENT_CLIAM_TYPES?.Miscellaneous]?.length || 0;

  const [claimType, setClaimType] = useState<ClaimType>(DefaultClaimType);
  const handleAccordionChange = (index: number | null) => {
    setExpandedIndex(index === expandedIndex ? null : index);
  };

  const dispatch = useAppDispatch();
  const claimRadioChange = (event: any) => {
    const { name, checked } = event.target;
    setClaimType({ ...claimType, [name]: checked });
    if (name === 'Travel') {
      const travel =
        APPLY_REIMBURSEMENT_TYPES?.ALREADY_EXISTED_TASK === claimTypeMode
          ? disableTravelField
          : initializeFormData(travelFormDataBlank);
      setTravelFormData(travel);
    } else if (name === 'Food') {
      setFoodFormData(initializeFormData(foodFormDataBlank));
    } else if (name === 'Accommodation') {
      setAccommodation(initializeAccommodationFormData(accommodationDataBlank));
    } else if (name === 'Miscellaneous') {
      setMiscellaneous(initializeFormData(miscellaneousDataBlank));
    }
  };

  useEffect(() => {
    dispatch(fetchReimbursementTypes({ module: 7 }));
    if (APPLY_REIMBURSEMENT_TYPES?.ALREADY_EXISTED_TASK === claimTypeMode) {
      reimbursementLocationDetails(
        setShowLoader,
        dispatch,
        setDisableTravelField,
        setTravelFormData,
        selectedTask
      );
    }
  }, []);

  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleIconClick = (claimType: number) => {
    if (fileInputRef.current) {
      fileInputRef.current.click(); // Trigger the file input click
      setActiveClaimUpload(claimType);
    }
  };

  const handleSubmit = () => {
    if (
      validation(
        imagesList,
        claimType,
        travelFormData,
        foodFormData,
        accommodation,
        miscellaneous
      )
    ) {
      const reqObject = getReqData(
        imagesList,
        claimType,
        travelFormData,
        foodFormData,
        accommodation,
        miscellaneous,
        selectedTask
      );
      setShowLoader(true);
      dispatch(postApplyReimbursement(reqObject.data))
        ?.then((fulfilled: any) => {
          setShowLoader(false);
          if (isAPIFailed(fulfilled?.payload)) {
            toast.error(fulfilled?.payload.responseInformation.responseMessage);
          } else if (isAPISuccess(fulfilled?.payload)) {
            if (reqObject.allSelectedFiles?.length) {
              uploadAttachments(
                reqObject.formData,
                {
                  reimbursementRequestId: fulfilled?.payload?.result,
                },
                setShowLoader,
                dispatch,
                toggleModal
              );
            } else {
              toast.success(
                fulfilled?.payload.responseInformation.responseMessage
              );
              toggleModal(CLICK_ACTIONS.NO_ACTION);
            }
          }
        })
        ?.catch(() => {
          setShowLoader(false);
        });
    }
  };

  const disableSubmitButton =
    !claimType?.Travel &&
    !claimType?.Food &&
    !claimType?.Miscellaneous &&
    !claimType?.Accommodation;

  const getTravelComponent = () => {
    return (
      <div>
        <Row>
          <Col xs={12} lg={6} className="re-claim-date-picker re-row-margin">
            <MDatePicker
              label="Claim Date and Time"
              value={travelFormData?.claimFromDate}
              onChange={(date: any) => {
                setTravelFormData({
                  ...travelFormData,
                  claimFromDate: date,
                });
              }}
              icon={<Image src={Calendar}></Image>}
              format="DD-MM-YYYY hh:mm a"
              maxDate={moment()}
              disabled={!!disableTravelField?.claimFromDate}
              disableFuture={true}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={6} className="re-row-margin">
            <MTextField
              classNames="re-text-field"
              label="Starting Point"
              required
              disabled={!!disableTravelField?.locationA}
              value={travelFormData?.locationA}
              onChange={(event: any) => {
                const value = event.target.value?.trimStart();
                if (value?.length <= 25) {
                  setTravelFormData({
                    ...travelFormData,
                    locationA: value,
                  });
                }
              }}
            />
          </Col>
          <Col xs={12} lg={6} className="re-row-margin">
            <MTextField
              classNames="re-text-field"
              label="Ending Point"
              required
              disabled={!!disableTravelField?.locationB}
              value={travelFormData?.locationB || ''}
              onChange={(event: any) => {
                const value = event.target.value?.trimStart();
                if (value?.length <= 25) {
                  setTravelFormData({
                    ...travelFormData,
                    locationB: value,
                  });
                }
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={6} className="re-row-margin">
            <MTextField
              label="Total Distance Travelled (Kms)"
              value={travelFormData?.totalDistance}
              required
              disabled={!!disableTravelField?.totalDistance}
              onChange={(event: any) => {
                const value = event.target.value.replace(regex, '');
                if (distanceRegex.test(value) || value === '') {
                  setTravelFormData({
                    ...travelFormData,
                    totalDistance: value,
                  });
                }
              }}
            />
          </Col>
          <Col xs={12} lg={6} className="re-row-margin">
            <MTextField
              label="Total Expense Incurred (INR)"
              value={travelFormData?.totalExpenses}
              required
              onChange={(event: any) => {
                const value = event.target.value.replace(regex, '');
                if (numberRestrictionRegex.test(value) || value === '') {
                  setTravelFormData({
                    ...travelFormData,
                    totalExpenses: value,
                  });
                }
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={6} className="re-row-margin">
            <MTextField
              label="Reason for Travel"
              value={travelFormData?.reason}
              required
              onChange={(event: any) => {
                if (event.target.value.length <= 25) {
                  setTravelFormData({
                    ...travelFormData,
                    reason: event.target.value,
                  });
                }
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={6} className="re-row-margin">
            <MTextField
              label="Any Documents"
              required
              value={
                imagesList?.[REIMBURSEMENT_CLIAM_TYPES?.Travel]?.length
                  ? 'Attached'
                  : ''
              }
              onChange={() => {}}
              icon={
                <Badge
                  badgeContent={travelImagesCount}
                  sx={{
                    '& .MuiBadge-badge': {
                      fontSize: 9,
                      height: 15,
                      minWidth: 15,
                      left: '1px',
                    },
                  }}
                  color="error"
                >
                  {' '}
                  <Image
                    src={Attachment}
                    alt="attachment"
                    onClick={() => {
                      handleIconClick(REIMBURSEMENT_CLIAM_TYPES?.Travel);
                    }}
                  ></Image>
                </Badge>
              }
            />
            <span className="uploade-files-span">
              you can upload up to 9 files max
            </span>
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={6} className="re-row-margin">
            <FormGroup>
              <Label for="comment" className="re-comment-title">
                Comments, if any
              </Label>
              <Input
                id="comment"
                name="comment"
                type="textarea"
                maxLength={250}
                value={travelFormData?.comments}
                placeholder="Please Comment"
                className="rounded border model-comment-area custom-input-area"
                onChange={(event) => {
                  setTravelFormData({
                    ...travelFormData,
                    comments: event.target.value,
                  });
                }}
              />
            </FormGroup>
          </Col>
        </Row>
      </div>
    );
  };
  const getFoodComponent = () => {
    return (
      <div>
        <Row>
          <Col xs={12} lg={6} className="re-claim-date-picker re-row-margin">
            <MDatePicker
              label="Claim Date and Time"
              value={foodFormData?.claimFromDate}
              onChange={(date: any) => {
                setFoodFormData({
                  ...foodFormData,
                  claimFromDate: date,
                });
              }}
              icon={<Image src={Calendar}></Image>}
              format="DD-MM-YYYY hh:mm a"
              maxDate={moment()}
              disableFuture={true}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={6} className="re-row-margin">
            <MTextField
              classNames="re-text-field"
              label="Location"
              value={foodFormData?.locationA}
              required
              onChange={(event: any) => {
                const value = event.target.value?.trimStart();
                if (value?.length <= 25) {
                  setFoodFormData({
                    ...foodFormData,
                    locationA: value,
                  });
                }
              }}
            />
          </Col>
          <Col xs={12} lg={6} className="re-row-margin">
            <MTextField
              classNames="re-text-field"
              label="Total Expense Incurred (INR)"
              value={foodFormData?.totalExpenses}
              required
              onChange={(event: any) => {
                const value = event.target.value.replace(regex, '');
                if (numberRestrictionRegex.test(value) || value === '') {
                  setFoodFormData({
                    ...foodFormData,
                    totalExpenses: value,
                  });
                }
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={6} className="re-row-margin">
            <MTextField
              classNames="re-text-field"
              label="Any Documents"
              required
              value={
                imagesList?.[REIMBURSEMENT_CLIAM_TYPES?.Food]?.length
                  ? 'Attached'
                  : ''
              }
              onChange={() => {}}
              icon={
                <Badge
                  badgeContent={foodImagesCount}
                  sx={{
                    '& .MuiBadge-badge': {
                      fontSize: 9,
                      height: 15,
                      minWidth: 15,
                      left: '1px',
                    },
                  }}
                  color="error"
                >
                  <Image
                    src={Attachment}
                    alt="attachment"
                    onClick={() => {
                      handleIconClick(REIMBURSEMENT_CLIAM_TYPES?.Food);
                    }}
                  ></Image>
                </Badge>
              }
            />
            <span className="uploade-files-span">
              you can upload up to 9 files max
            </span>
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={6} className="re-row-margin">
            <FormGroup>
              <Label for="comment" className="re-comment-title">
                Comments, if any
              </Label>
              <Input
                id="comment"
                name="comment"
                type="textarea"
                maxLength={250}
                value={foodFormData?.comments}
                placeholder="Please Comment"
                className="rounded border model-comment-area custom-input-area"
                onChange={(event) => {
                  setFoodFormData({
                    ...foodFormData,
                    comments: event.target.value,
                  });
                }}
              />
            </FormGroup>
          </Col>
        </Row>
      </div>
    );
  };
  const getAccommodationComponent = () => {
    return (
      <div>
        <Row>
          <Col xs={12} lg={6} className="re-claim-date-picker re-row-margin">
            <MDatePicker
              label="Claim From Date and Time"
              value={accommodation?.claimFromDate}
              onChange={(date: any) => {
                setAccommodation({ ...accommodation, claimFromDate: date });
              }}
              icon={<Image src={Calendar}></Image>}
              format="DD-MM-YYYY hh:mm a"
              maxDate={moment()}
              disableFuture={true}
            />
          </Col>
          <Col xs={12} lg={6} className="re-claim-date-picker re-row-margin">
            <MDatePicker
              label="Claim To Date and Time"
              value={accommodation?.claimToDate}
              onChange={(date: any) => {
                setAccommodation({ ...accommodation, claimToDate: date });
              }}
              icon={<Image src={Calendar}></Image>}
              format="DD-MM-YYYY hh:mm a"
              maxDate={moment()}
              disableFuture={true}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} className="re-row-margin">
            <MTextField
              classNames="re-text-field"
              label="Location"
              value={accommodation?.locationA}
              required
              onChange={(event: any) => {
                const value = event.target.value?.trimStart();
                if (value?.length <= 25) {
                  setAccommodation({
                    ...accommodation,
                    locationA: value,
                  });
                }
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} className="re-row-margin">
            <MTextField
              classNames="re-text-field"
              label="Hotel Name"
              required
              value={accommodation?.hotelName}
              onChange={(event: any) => {
                if (event.target.value?.length <= 25) {
                  setAccommodation({
                    ...accommodation,
                    hotelName: event.target.value,
                  });
                }
              }}
            />
          </Col>
        </Row>
        <div className="mt-3">
          <MUILocationFilter
            size={{
              zone: colSize,
              state: colSize,
              district: colSize,
              city: colSize,
            }}
            required={true}
            filterData={{
              zone: accommodation.zone,
              state: accommodation.state,
              district: accommodation.district,
              city: accommodation.city,
            }}
            setLocationFilter={(filter: MUILocationFilterType) => {
              setAccommodation({
                ...accommodation,
                zone: filter.zone,
                state: filter.state,
                district: filter.district,
                city: filter.city,
                pincode: filter.pincode ?? '',
              });
            }}
            labels={{ city: 'City / Village' }}
            dataTestIds={{
              zone: 'zone',
              state: 'state',
              district: 'district',
              city: 'village',
            }}
          />
        </div>
        <Row>
          <Col xs={12} lg={6} className="re-row-margin">
            <MTextField
              classNames="re-text-field"
              label="Total Expense Incurred (INR)"
              value={accommodation?.totalExpenses}
              required
              onChange={(event: any) => {
                const value = event.target.value.replace(regex, '');
                if (numberRestrictionRegex.test(value) || value === '') {
                  setAccommodation({
                    ...accommodation,
                    totalExpenses: value,
                  });
                }
              }}
            />
          </Col>

          <Col xs={12} lg={6} className="re-row-margin">
            <MTextField
              classNames="re-text-field"
              label="Reason for Stay"
              value={accommodation?.reason}
              required
              onChange={(event: any) => {
                if (event.target.value.length <= 25) {
                  setAccommodation({
                    ...accommodation,
                    reason: event.target.value,
                  });
                }
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={6} className="re-row-margin">
            <MTextField
              classNames="re-text-field"
              label="Any Documents"
              required
              value={
                imagesList?.[REIMBURSEMENT_CLIAM_TYPES?.Accommodation]?.length
                  ? 'Attached'
                  : ''
              }
              onChange={() => {}}
              icon={
                <Badge
                  badgeContent={accomadationImagesCount}
                  sx={{
                    '& .MuiBadge-badge': {
                      fontSize: 9,
                      height: 15,
                      minWidth: 15,
                      left: '1px',
                    },
                  }}
                  color="error"
                >
                  <Image
                    src={Attachment}
                    alt="attachment"
                    onClick={() => {
                      handleIconClick(REIMBURSEMENT_CLIAM_TYPES?.Accommodation);
                    }}
                  ></Image>
                </Badge>
              }
            />
            <span className="uploade-files-span">
              you can upload up to 9 files max
            </span>
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={6} className="re-row-margin">
            <FormGroup>
              <Label for="comment" className="re-comment-title">
                Comments, if any
              </Label>
              <Input
                id="comment"
                name="comment"
                type="textarea"
                maxLength={250}
                value={accommodation?.comments}
                placeholder="Please Comment"
                className="rounded border model-comment-area custom-input-area"
                onChange={(event) => {
                  setAccommodation({
                    ...accommodation,
                    comments: event.target.value,
                  });
                }}
              />
            </FormGroup>
          </Col>
        </Row>
      </div>
    );
  };
  const getMiscellaneousComponent = () => {
    return (
      <div>
        <Row>
          <Col xs={12} lg={6} className="re-claim-date-picker re-row-margin">
            <MDatePicker
              label="Claim From Date and Time"
              value={miscellaneous?.claimFromDate}
              onChange={(date: any) => {
                setMiscellaneous({ ...miscellaneous, claimFromDate: date });
              }}
              icon={<Image src={Calendar}></Image>}
              format="DD-MM-YYYY hh:mm a"
              maxDate={moment()}
              disableFuture={true}
            />
          </Col>
          <Col xs={12} lg={6} className="re-claim-date-picker re-row-margin">
            <MTextField
              classNames="re-text-field"
              label="Miscellaneous"
              value={miscellaneous?.locationA}
              required
              onChange={(event: any) => {
                const value = event.target.value.replace(alphabetRegex, '');
                if (value?.length <= 25) {
                  setMiscellaneous({
                    ...miscellaneous,
                    locationA: value,
                  });
                }
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={6} className="re-row-margin">
            <MTextField
              classNames="re-text-field"
              label="Total Expense Incurred (INR)"
              required
              value={miscellaneous?.totalExpenses}
              onChange={(event: any) => {
                const value = event.target.value.replace(regex, '');
                if (numberRestrictionRegex.test(value) || value === '') {
                  setMiscellaneous({
                    ...miscellaneous,
                    totalExpenses: value,
                  });
                }
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={6} className="re-row-margin">
            <MTextField
              classNames="re-text-field"
              label="Any Documents"
              required
              value={
                imagesList?.[REIMBURSEMENT_CLIAM_TYPES?.Miscellaneous]?.length
                  ? 'Attached'
                  : ''
              }
              onChange={() => {}}
              icon={
                <Badge
                  badgeContent={miscellaneousImagesCount}
                  sx={{
                    '& .MuiBadge-badge': {
                      fontSize: 9,
                      height: 15,
                      minWidth: 15,
                      left: '1px',
                    },
                  }}
                  color="error"
                >
                  <Image
                    src={Attachment}
                    alt="attachment"
                    onClick={() => {
                      handleIconClick(REIMBURSEMENT_CLIAM_TYPES?.Miscellaneous);
                    }}
                  ></Image>
                </Badge>
              }
            />
            <span className="uploade-files-span">
              you can upload up to 9 files max
            </span>
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={6} className="re-row-margin">
            <FormGroup>
              <Label for="comment" className="re-comment-title">
                Comments, if any
              </Label>
              <Input
                id="comment"
                name="comment"
                type="textarea"
                maxLength={250}
                value={miscellaneous?.comments}
                onChange={(event: any) => {
                  setMiscellaneous({
                    ...miscellaneous,
                    comments: event.target.value,
                  });
                }}
                placeholder="Please Comment"
                className="rounded border model-comment-area custom-input-area"
              />
            </FormGroup>
          </Col>
        </Row>
      </div>
    );
  };
  const getMainComponent = (claim: any) => {
    switch (claim) {
      case TYPE_OF_CLAIM[0]?.value:
        return getTravelComponent();
      case TYPE_OF_CLAIM[1]?.value:
        return getFoodComponent();
      case TYPE_OF_CLAIM[2]?.value:
        return getAccommodationComponent();
      case TYPE_OF_CLAIM[3]?.value:
        return getMiscellaneousComponent();
    }
  };
  useEffect(() => {
    if (TYPE_OF_CLAIM?.length) {
      setClaimType({ ...claimType, Travel: true });
    }
  }, [TYPE_OF_CLAIM]);

  return (
    <ModalComponent
      isOpen={isOpen}
      toggle={() => {
        toggleModal(CLICK_ACTIONS.NO_ACTION);
      }}
      className="modalWrapper"
      backdrop="static"
    >
      <div className="d-flex justify-content-center">
        <div className="bg-white rounded border re-modal-width">
          <div className="m-2">
            <ModalHeader
              closeOnly={modalType === MODAL_TYPE.apply}
              toggle={toggleModal}
            />
          </div>

          <div className="re-parent apply-reimbursement-modal">
            <div className="re-task-title">
              {claimTypeMode === APPLY_REIMBURSEMENT_TYPES?.NEW_TASK ? (
                <span className="re-task-id">Raise a Claim </span>
              ) : (
                <>
                  {' '}
                  <span className="re-task-id">
                    {selectedTask?.taskId || '-'}{' '}
                  </span>{' '}
                  <span className="re-task-name">
                    ({selectedTask?.taskName}){' '}
                  </span>
                </>
              )}
            </div>

            <div className="re-claim-parent">
              <div className="re-type-claim">Types of Claim</div>
              <Form>
                <div className="d-flex justify-content-between flex-wrap">
                  {TYPE_OF_CLAIM?.map((item, index) => (
                    <Form.Check
                      key={item?.value}
                      inline
                      label={item.label}
                      value={String(
                        claimType?.[item?.label as keyof ClaimType]
                      )}
                      name={`${item?.label}`}
                      type="checkbox"
                      id={`${item.value}-radio-${index}`}
                      className={
                        String(claimType?.[item?.label as keyof ClaimType]) ===
                        item.value
                          ? 're-type-claim-selected'
                          : 're-type-claim-unselected'
                      }
                      defaultChecked={
                        claimType?.[item?.label as keyof typeof claimType]
                      }
                      onChange={(event: any) => {
                        claimRadioChange(event);
                        const isChecked = event.target.checked;

                        if (!isChecked && imagesList?.[item.value]?.length) {
                          setImagesList((prev: any) => ({
                            ...prev,
                            [item.value]: [],
                          }));
                        }
                        if (isChecked) {
                          setExpandedIndex(index);
                        } else if (index === expandedIndex) {
                          setExpandedIndex(null);
                        } else if (
                          expandedIndex != null &&
                          index < expandedIndex
                        ) {
                          setExpandedIndex(expandedIndex - 1);
                        }
                      }}
                    />
                  ))}
                </div>
              </Form>
            </div>
            {TYPE_OF_CLAIM?.length > 0 &&
              TYPE_OF_CLAIM?.filter(
                (item: any) => claimType?.[item?.label as keyof ClaimType]
              )?.map((item, index) => (
                <Accordion
                  key={item?.value}
                  expanded={index === expandedIndex}
                  onChange={() => handleAccordionChange(index)}
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: '14px',
                      }}
                    >
                      {item?.label}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>{getMainComponent(item?.value)}</Typography>
                  </AccordionDetails>
                </Accordion>
              ))}
            <input
              type="file"
              ref={fileInputRef}
              multiple
              accept="image/png, image/jpg, image/jpeg"
              style={{ display: 'none' }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                handleFileChange(
                  event,
                  imagesList,
                  activeClaimUpload,
                  setImagesList,
                  setActiveClaimUpload,
                  fileInputRef
                );
              }}
            />
          </div>
          <div className="d-flex flex-column align-items-center  re-button-parent">
            {disableSubmitButton && (
              <span className="uploade-files-span">
                Please select atleast one claim to submit{' '}
              </span>
            )}
            <div className="d-flex justify-content-center flex-wrap">
              <Button
                variant="primary"
                className="me-md-2 cl-btn-primary mb-2 mb-md-0"
                onClick={() => {
                  handleSubmit();
                }}
                disabled={disableSubmitButton}
              >
                Submit
              </Button>
              <Button
                variant="outline-primary"
                className="ms-md-3 cl-btn-outline-primary"
                onClick={() => {
                  toggleModal();
                }}
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
        <CenterSpinner showLoader={showLoader} className="spinner-60" />
      </div>
    </ModalComponent>
  );
};

export default ApplyReimbursementModal;
